
import siteLogo from "../assets/sitelogo.svg";
export default function LogoUploader({ defaultLogo, onSelect }) {   // change onChange -> onSelect
  return (
    <div className="logo-uploader">
      <img
        src={
          defaultLogo
            ? defaultLogo.startsWith("http")
              ? defaultLogo
              : `${process.env.REACT_APP_BUCKET_URL}${defaultLogo}`
            : siteLogo
        }
        alt="Site Logo"
        onClick={() => onSelect()}
        style={{ maxWidth: "180px", height: "40px", cursor: "pointer" }}
      />

    </div>
  );
}
